
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.85 8a5.85 5.85 0 10-11.7 0 5.85 5.85 0 0011.7 0zM.8 8a7.2 7.2 0 1114.4 0A7.2 7.2 0 01.8 8zm4.995 1.746A2.963 2.963 0 008 10.7a2.963 2.963 0 002.205-.954.675.675 0 01.993.914 4.307 4.307 0 01-3.195 1.39 4.292 4.292 0 01-3.195-1.39.673.673 0 01.039-.953.673.673 0 01.953.04h-.005zM4.86 6.65a.9.9 0 111.8 0 .9.9 0 01-1.8 0zm4.663.61a.561.561 0 01-.796.025.561.561 0 01-.025-.796c.408-.435.99-.627 1.536-.627.545 0 1.127.192 1.535.627a.564.564 0 01-.821.771c-.155-.163-.416-.273-.714-.273-.299 0-.56.107-.715.273z","fill":"#282E3E"}})])
          )
        }
      }
    